import { useGetDealsList } from '../hooks';
import { DealTile } from '.';
import { useDealsContext } from '../containers/Deals/Deals';

const ListViewHeaders = () => (
  <div className="grid grid-cols-10 border-b border-separator-primary pl-5 pb-[22px]">
    <p className="col-span-2 text-[16px] font-semibold">Deal Name</p>
    <p className="col-span-1 text-[16px] font-semibold">Closed Date</p>
    <p className="col-span-1 text-[16px] font-semibold">Amount</p>
    <p className="col-span-2 text-[16px] font-semibold">Company</p>
    <p className="col-span-1 text-[16px] font-semibold">Contact</p>
    <p className="col-span-2 text-[16px] font-semibold">Stages</p>
  </div>
);

const DealsList = () => {
  const { pipelineId, query } = useDealsContext();
  const { data: deals } = useGetDealsList({ ...query, pipelineId });

  return (
    <div className="mt-[30px]">
      <ListViewHeaders />
      <div className="mt-4 max-h-[calc(100vh-415px)] space-y-2.5">
        {deals?.map((deal) => (
          <DealTile
            amount={deal._amount}
            name={deal.name}
            closedAt={deal.closedAt}
            pipelineId={pipelineId}
            key={deal._id}
            contacts={deal.leadId}
            company={deal.companyId?.name}
            stageId={deal.stageId as string}
            id={deal._id}
          />
        ))}
      </div>
    </div>
  );
};

export default DealsList;
